const TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';

// 获取访问令牌
export const getAccessToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

// 设置访问令牌
export const setAccessToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

// 移除访问令牌
export const removeToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
};

// 获取刷新令牌
export const getRefreshToken = (): string | null => {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
};

// 设置刷新令牌
export const setRefreshToken = (token: string): void => {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
};
  
export const setCurrentAuthority = (currentAuthority: string) =>  {
    localStorage.setItem('app.user.authority', currentAuthority);
}

export const getCurrentAuthority = () => {
    return localStorage.getItem('app.user.authority');
}

// 检查是否有访问令牌
export const hasAccessToken = (): boolean => {
  return !!getAccessToken();
};

// 清除所有认证相关数据
export const clearAuthData = (): void => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem('user');
  localStorage.removeItem('permissions');
  localStorage.removeItem('roles');
}; 